import React, { useState, useEffect } from "react";
import { UncontrolledButtonDropdown, DropdownMenu, Nav, NavLink, DropdownToggle } from "reactstrap";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { getHeaderTooltip } from "../tooltips";

export default function SelectColumnHeader({
  value,
  setValue,
  name,
  options = [],
  isLock,
  isHidden,
  direction = "down",
  headerType,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (newValue) => {
    setIsOpen(false);
    setValue(newValue);
  };

  const handleOpen = () => {
    if (isHidden) return;
    setIsOpen((prev) => !prev);
  };

  const getSelectName = () => {
    if (headerType === "Mc") {
      return (
        <button
          className={`d-flex justify-content-center align-items-center border rounded planscreen__column-header ${value === "N"
            ? "planscreen__column-header--disabled"
            : ""
            }`}
          onClick={handleOpen}
          disabled={isLock}
          data-col-name={name}
          data-col-value={value}
        >
          {value === "N" ? name : value}
        </button>
      );
    }

    switch (value) {
      case "N":
        return (
          <button
            className="d-flex justify-content-center align-items-center border rounded planscreen__column-header planscreen__column-header--disabled"
            onClick={handleOpen}
            disabled={isLock}
            data-col-name={name}
            data-col-value={value}
          >
            {name}
          </button>
        );

      default:
        return (
          <button
            className="d-flex justify-content-center align-items-center border rounded planscreen__column-header"
            onClick={handleOpen}
            disabled={isLock}
            data-col-name={name}
            data-col-value={value}
          >
            <i className="planscreen__column-header-name">{name}</i>
            <i className="planscreen__column-header-value">{value}</i>
          </button>
        );
    }
  };

  const tip = getHeaderTooltip(name, value);
  const button = getSelectName();

  return (
    <div className="dropdown-wrapper" style={{ position: "relative" }}>
      <UncontrolledButtonDropdown isOpen={isOpen} direction={direction}>
        <DropdownToggle tag="div" color="link" className="p-0">
          {tip ? (
            <Tippy content={tip} placement="top" arrow>
              <span>{button}</span>
            </Tippy>
          ) : (
            button
          )}
        </DropdownToggle>

        <DropdownMenu
          className={`rm-pointers dropdown-menu-lg menu-dropdown planscreen__dropdown--km ${isOpen ? "planscreen__dropdown--open" : "planscreen__dropdown"
            }`}
          container="body"
          strategy="fixed"
          popperConfig={{
            strategy: "fixed",
            modifiers: [
              { name: "preventOverflow", options: { boundary: document.body } },
              { name: "computeStyles", options: { adaptive: false } },
            ],
          }}
        >
          <Nav vertical>
            {options.map((option, index) => (
              <NavLink
                key={index}
                onClick={() => handleClick(option.value)}
                active={option.value === value}
                data-opt-value={option.value}
                data-opt-label={option.label}
              >
                {option.label}
              </NavLink>
            ))}
          </Nav>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </div>
  );
}
